var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.069 11.13a.999.999 0 00-1.707-.707L9.986 20.798a4.069 4.069 0 01-2.895 1.199 4.063 4.063 0 01-2.895-1.2 4.101 4.101 0 010-5.79L16.232 2.972c.679-.68 1.333-1.005 1.944-.97.595.037 1.054.413 1.275.634.373.373.529.776.471 1.23-.071.57-.462 1.224-1.133 1.895l-9.444 9.443a.999.999 0 101.414 1.414l9.445-9.443c1.002-1.002 1.574-2.032 1.703-3.061.134-1.08-.227-2.078-1.042-2.892-.727-.728-1.64-1.16-2.57-1.215-1.207-.072-2.377.45-3.477 1.55L2.782 13.593a6.102 6.102 0 000 8.619 6.052 6.052 0 004.309 1.785 6.058 6.058 0 004.31-1.785l10.375-10.375a.997.997 0 00.293-.707",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconAttachment;